<script setup>
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['openDrawer']);

const { t } = useI18n();

const handleClick = () => {
  emit('openDrawer');
};
</script>

<template>
  <button
    class="group flex w-full items-center gap-2 px-3 py-2.5 text-xs font-medium text-n-slate-10 transition-all rounded-xl hover:bg-n-alpha-2 hover:text-n-brand border-2 border-dashed border-transparent hover:border-n-brand/30"
    @click="handleClick"
  >
    <span
      class="i-lucide-plus size-4 transition-transform group-hover:rotate-90"
    />
    <span>{{ t('TASKS.ADD_CARD') }}</span>
  </button>
</template>
